import ArgumentsBox from './ArgumentsBox.jsx'
import ResultBox from './ResultBox.jsx'
import styles from './AIResponseLog.module.scss'

/**
 * @param {{
 *   arguments?: string | Record<string, unknown>,
 *   result?: string | Record<string, unknown>,
 *   stream?: {
 *     loading?: boolean,
 *     argumentsText?: string,
 *     resultText?: string,
 *   },
 *   expanded: boolean,
 * }} props
 */
export default function ActionCard({ arguments: args, result, stream, expanded }) {
  if (!expanded) return null

  const argsPayload = stream?.argumentsText ?? args
  const resultPayload = stream?.resultText ?? result
  const showArgs = stream?.loading || (typeof argsPayload === 'string' ? argsPayload.length > 0 : argsPayload != null)
  const showResult =
    !stream?.loading &&
    (typeof resultPayload === 'string' ? resultPayload.length > 0 : resultPayload != null)

  return (
    <div className={styles.actionCard}>
      {stream?.loading ? (
        <div className={styles.payloadSection}>
          <span className={styles.payloadLabel}>Arguments:</span>
          <div className={styles.payloadLoading}>Loading…</div>
        </div>
      ) : null}
      {showArgs && !stream?.loading ? <ArgumentsBox payload={argsPayload} /> : null}
      {showResult ? <ResultBox payload={resultPayload} /> : null}
    </div>
  )
}
